module.exports = __webpack_public_path__ + "img/hr-sand-decal-23.da11fe0f.png";